export default __webpack_public_path__ + "static/media/Versions - Differences - Side-by-side.b454a032.png";